export default function () {
	return {
		showAllOptions: false,
		searchQuery: null,

		search() {
			const options = this.$root.querySelectorAll('li')

			if (!this.searchQuery) {
				options.forEach((option) => {
					option.classList.remove('hidden')
				})

				return
			}

			this.showAllOptions = true

			const searchQuery = this.searchQuery.toLowerCase()

			options.forEach((option) => {
				const optionText = option.textContent.toLowerCase()

				if (optionText.includes(searchQuery)) {
					option.classList.remove('hidden')
				}
				else {
					option.classList.add('hidden')
				}
			})
		},
	}
}
